var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.7071 7.70698C7.51957 7.89445 7.26526 7.99976 7.0001 7.99976C6.73493 7.99976 6.48063 7.89445 6.2931 7.70698L0.636099 2.04998C0.540589 1.95773 0.464406 1.84739 0.411997 1.72538C0.359588 1.60338 0.332002 1.47216 0.330848 1.33938C0.329694 1.2066 0.354996 1.07492 0.405277 0.952023C0.455558 0.829127 0.529811 0.717474 0.623704 0.623581C0.717597 0.529689 0.829248 0.455436 0.952145 0.405155C1.07504 0.354874 1.20672 0.329572 1.3395 0.330726C1.47228 0.33188 1.6035 0.359466 1.7255 0.411875C1.84751 0.464284 1.95785 0.540466 2.0501 0.635976L7.0001 5.58598L11.9501 0.635976C12.1387 0.453818 12.3913 0.353024 12.6535 0.355302C12.9157 0.357581 13.1665 0.46275 13.3519 0.648158C13.5373 0.833566 13.6425 1.08438 13.6448 1.34658C13.6471 1.60877 13.5463 1.86137 13.3641 2.04998L7.7071 7.70698Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownarrow);
export default __webpack_public_path__ + "static/media/downarrow.47840714fda93352e3c2e9da3fe48441.svg";
export { ForwardRef as ReactComponent };